import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Drawer, List } from '@material-ui/core';
import { isMobile, isTablet } from 'react-device-detect';
import MyBadge from '../components/badge/MyBadge';
import { CartCountBadge } from '../components/badge/MyCartBadge'
import { StyledMenu, StyledMenuItem } from '../components/topBar/SubMenu';
import { Vdivider, HorizontalSp, VerticalSp, MediaQuery, HSLine } from '../components/Common';
import { BlockReqBtn } from '../components/guide/license';
import {
  TopBar,
  TopBarList,
  TopBarItem,
  GnbExpoMenu,
  GnbExpoMenuVer2,
  GnbExpoMenuVer3,
  GnbExpoMenuVerSeller,
  GnbExpoMenuVer4,
  GnbExpoMenuVer5,
  GnbExpoMenuVer6,
  GnbPrevMenu,
  GnbMenuItem,
  GnbMenuItemVer2,
  GnbMenuItemVer3,
  GnbMenuItemVer4,
  GnbMenuGroup,
  LanguageBtn,
  subMenuListGroup

} from '../components/topBar/TopBar';

import { HeaderPC } from '../components/topBar/headerPC';
import { HeaderMobile } from '../components/topBar/headerMobile';
import { HeaderMobileWide } from '../components/topBar/headerMobileWide';
import { HeaderTablet } from '../components/topBar/headerTablet';
import {
  DesignMenu,
  DesignGroupBlock,
  DesignGroupBtn,
  DesignDetailBlock,
  DesignDetailColumn,
  DesignDetailBtn,
} from '../components/topBar/DesignMenu';
import { SearchMenu, SearchBase } from '../components/topBar/SearchMenu';
import { withTranslation } from 'react-i18next';
import Store from 'store';
import Select from 'react-select';
import store from '../store';
import apiClient from '../_utils/axios';
import slangKo from '../json/slang_ko';
import slangEn from '../json/slang_en';
// import './scss/style.scss';
import './Styles.scss';

import images from '../assets';
import { AuthMiniButton } from '../components/auth/login';
import { marketingApi } from '../marketing-api';
import Collapse from '@material-ui/core/Collapse';

//서치 테스트 
import { SearchMenuV2, SearchBaseV2, SearchResults, ResultsItem, Hightlight } from '../components/topBar/SearchMenu';
import { InputBase } from '@material-ui/core';


const searchStyle = {
  control: (base) => ({
    ...base,
    border: 0,
    boxShadow: 'none',
    zIndex: 900,
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: '#fff',
      color: '#000',
      cursor: 'default',
      background: isFocused ? '#eee' : isSelected ? '#eee' : undefined,
      zIndex: 900,
    };
  },
};


class Header extends React.Component {
  state = {
    overbtn: '',
    overgroup: 'all',
    overdetail: 'all',
    sevmenu: '',
    draweropen: false,
    basketdraweropen: false,
    basicdraweropen: true,
    searchkey: '',
    activeCategoryImg: '',
    keywordList: [],
    selectCategory: '',
    selectCategoryNameKo: '',
    selectCategoryNameEn: '',
    generalDitemopen: false,
    buyerDitemopen: false,
    sellerDitemopen: false,
    aiDitemopen: false,
    uscopyrightDitemopen: false,
    creditDitemopen: false
  };

  constructor(props) {
    super(props);
    this.designTopMenuRef = React.createRef();
    this.designMenuRef = React.createRef();
    this.priceMenuRef = React.createRef();
    this.guideMenuRef = React.createRef();
    this.profileMenuRef = React.createRef();
    this.mybasketRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  onGoHome = async () => {
    this.hideMenu();
    this.props.history.push('/');
  };

  onGoSignup = () => {
    this.hideMenu();
    this.props.history.push('/auth/signup');
  }

  onGoAuth = () => {
    this.hideMenu();
    this.props.history.push('/auth');
  };

  hideMenu = () => {
    this.setState({ overbtn: '', draweropen: false, basketdraweropen: false});
  };

  onMyPage = () => {
    this.hideMenu();
    this.props.history.push('/mypage');
  };

  changeState = (state, value) => {
    if(state === 'overbtn'){
      this.setState({ overbtn: value });
    }
    if(state === 'sevmenu'){
      this.setState({ sevmenu: value });
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  handleClickOutside(event) {
    const { overbtn } = this.state; 
    
    if (overbtn === 'design' &&this.designMenuRef.current && this.designTopMenuRef.current && !this.designMenuRef.current.contains(event.target)&& !this.designTopMenuRef.current.contains(event.target)) {
      this.setState({ overbtn: '' });
    }
    if (overbtn === 'price' && this.priceMenuRef.current && !this.priceMenuRef.current.contains(event.target)) {
      this.setState({ overbtn: '' });
    }
    if (overbtn === 'guide' && this.guideMenuRef.current && !this.guideMenuRef.current.contains(event.target)) {
      this.setState({ overbtn: '' });
    }
    if (overbtn === 'myprofile' && this.profileMenuRef.current && !this.profileMenuRef.current.contains(event.target)) {
      this.setState({ overbtn: '' });
    }
    if (overbtn === 'mybasket' && this.mybasketRef.current && !this.mybasketRef.current.contains(event.target)) {
      this.setState({ overbtn: '' });
    }
  }

  //3. AI 디자인 제작 서비스
  onGoAiGenerate = () => {
    this.hideMenu();
    this.props.history.push('/mypage/generate/result');
  }

  //5. VIP Seller 신청하기 
  onGoApplyForVIPSeller = () => {
    this.hideMenu();
    this.props.history.push('/mypage/vipreq');
  }

  onLogout = () => {
    localStorage.removeItem('authdata');
    localStorage.removeItem('userData');
    localStorage.removeItem('accessToken');
    window.location.href = '/';
  };

  onGoBankIntro = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/intro');
  };

  onGoAgentIntro = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/intro/agent');
  };

  onGoFaqIntro = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/intro/faq');
  };


  onOpenGnbMenu = () => {
    const { draweropen, overbtn } = this.state;
    this.hideMenu();
    
    if (overbtn === 'search') {
      this.setState({ draweropen: !draweropen, overbtn: '' });
    } else {
      this.setState({ draweropen: !draweropen });
    }
  };

  // 모바일, 태블릿 버전에서 장바구니 아이콘을 클릭했을 때 호출되는 함수 
  onOpenBasketRightGnbMenu = () => {
    this.hideMenu();
    const { basketdraweropen, overbtn } = this.state;
    if (overbtn === 'search') {
      this.setState({ basketdraweropen: !basketdraweropen, overbtn: '' });
    } else {
      this.setState({ basketdraweropen: !basketdraweropen });
    }
  };

  onGoLicenseGuide = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/guide');
  };

  onGoSellerGuide = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/guide/seller');
  };

  onGoBuyerGuide = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/guide/buyer');
  };

  onGoVipGuide = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/guide/vip');
  };

  onGoTrends = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/trend');
  };

  onGoAIGenerateIntro = (e) => {

    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/generate/intro/0');
  };
  onGoAIGeneratePrice = (e) => {

    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/generate/intro/1');
  };

  onGoAIGenerateService = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/generate/service');
  };

  onBasicPage = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/basic');
  };

  onReqSeller = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/basic/reqseller');
  };

  onAlarmList = (e) => {
    
    marketingApi.useClickGnbEffect(e.target.innerText === '' ? '알림함' : e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/basic/alerms');
  };

  onSvcCenter = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/basic/svccenter');
  };

  onPurchase = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/purchase');
  };

  onBasket = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText === '' ? '장바구니' : e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/purchase/basket');
  };

  onFavority = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText === '' ? '관심상품' : e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/purchase/favori');
  };

  onDesigner = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/purchase/designer');
  };

  onSales = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/sales');
  };

  onRegister = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/sales/editgood/register');
  };

  onSell = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/sales/sell');
  };

  onWithdrawal = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/sales/withdraw');
  };

  onCalculate = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/sales/calculate');
  };


  onGoAIGenerateResult = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/generate/result');
  };

  onGoAIGeneratePurchase = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/generate/purchase');
  };

  onGoAIGenerateBasket = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/generate/basket');
  };
  onApplyAgent = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/agentreq');
  }
  onAgencyList = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/agency');
  };


  onCreditPurchaseList = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/credit/purchasecredit/0');
  }

  onCreditRefundList = (e) => {
    marketingApi.useClickGnbEffect(e.target.innerText);
    this.hideMenu();
    this.props.history.push('/mypage/credit/refundcredit');
  }



  getKeyword = async () => {
    const { searchkey } = this.state;
    this.setState({
      keywordList: [],
    });
    const res = await apiClient.get(`/web/keyword?page=1&size=5&searchText=${searchkey}`);
    if (res) {
      const { keywordList } = this.state;
      for (const v of res.data.data) {
        keywordList.push({ label: v.keyword_name, value: v.keyword_name });
      }
      this.setState(keywordList);
    }
  };

  goSearch = async (keyword) => {
    


    if (!slangKo.includes(keyword) && !slangEn.includes(keyword)) {
      const res = await apiClient.post('/web/keyword', {
        keyword_name: keyword,
      });

      if (res) {
        marketingApi.useSeacrhEffect(keyword);
        this.hideMenu();
        this.props.history.push(`/design/all/all?keyword=${keyword}`);

      }
    } else {
      this.hideMenu();
      this.props.history.push(`/design/all/all?keyword=${keyword}`);

    }
  };

  render() {
    const { t, i18n } = this.props;
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      Store.set('lang', lng);
      window.location.reload();
    };
    const { generalDitemopen, buyerDitemopen, sellerDitemopen, aiDitemopen, uscopyrightDitemopen, creditDitemopen } = this.state
    const { overbtn, overgroup, overdetail, sevmenu, activeCategoryImg, keywordList, searchkey } = this.state;
    const { draweropen, basketdraweropen, basicdraweropen, selectCategory, selectCategoryNameKo, selectCategoryNameEn } = this.state;
    const { category, style } = store.getState();
    const { totalCartCount, cartCount, aiCartCount } = store.getState();
    const authdata = localStorage.getItem('userData');
    return (
      <>
        <div style={{ position: 'fixed', top: 0, width: '100%', backgroundColor: 'white', zIndex: 9999 }}>
          <TopBar>
             {/* pc 해더 1424px 이상 */}
             <MediaQuery min={1424}>
                <HeaderPC
                  t={t}
                  i18n={i18n}
                  sevmenu={sevmenu}
                  overbtn={overbtn}
                  changeState={this.changeState}
                  totalCartCount={totalCartCount}
                  onOpenBasketRightGnbMenu={this.onOpenBasketRightGnbMenu} 
                  hideMenu={this.hideMenu}
                />
              </MediaQuery>
              {/* 태블릿 세로 해더 1024 ~ 1423px */}
              <MediaQuery max={1423} min={1224}>
                <HeaderTablet
                  t={t}
                  i18n={i18n}
                  sevmenu={sevmenu}
                  hideMenu={this.hideMenu}
                  ref={this.designTopMenuRef}
                  priceMenuRef={this.priceMenuRef}
                  guideMenuRef={this.guideMenuRef}
                  profileMenuRef={this.profileMenuRef}
                  mybasketRef={this.mybasketRef}
                  overbtn={overbtn}
                  changeState={this.changeState}
                  totalCartCount={totalCartCount}
                  onOpenBasketRightGnbMenu={this.onOpenBasketRightGnbMenu} 
                  onOpenGnbMenu={this.onOpenGnbMenu} 
                />
              </MediaQuery>
              {/* 모바일 해더 1023 미만 */}
              <MediaQuery max={1223} >
                <HeaderMobile 
                  hideMenu={this.hideMenu}
                  changeState={this.changeState}
                  onOpenGnbMenu={this.onOpenGnbMenu} 
                  onOpenBasketRightGnbMenu={this.onOpenBasketRightGnbMenu} 
                />
              </MediaQuery>
          </TopBar>
          <MediaQuery min={1224}>
            {overbtn === 'design' && (
              <DesignMenu onMouseLeave={this.hideMenu} ref={this.designMenuRef}>
                <DesignGroupBlock>
                  <MediaQuery min={1424}>
                    <DesignGroupBtn
                      title={t('all_designs')}
                      active={overgroup === 'all'}
                      onMouseEnter={() => {
                        this.setState({ overgroup: 'all' });
                      }}
                      
                    />
                    {category.map((item, index) => (
                      <DesignGroupBtn
                        key={index}
                        title={Store.get('lang') === 'kr' ? item.ctg_name_ko : item.ctg_name_en}
                        active={overgroup === item.ctg_id}
                        onMouseEnter={() => {
                          this.setState({ overgroup: item.ctg_id, activeCategoryImg: item.ctg_main_img });
                        }}
                      />
                    ))}
                  </MediaQuery>
                  <MediaQuery max={1423}>
                    <DesignGroupBtn
                      title={t('all_designs')}
                      active={overgroup === 'all'}
                      onClick={() => {
                        this.setState({ overgroup: 'all' });
                      }}
                      
                    />
                    {category.map((item, index) => (
                      <DesignGroupBtn
                        key={index}
                        title={Store.get('lang') === 'kr' ? item.ctg_name_ko : item.ctg_name_en}
                        active={overgroup === item.ctg_id}
                        onClick={() => {
                          this.setState({ overgroup: item.ctg_id, activeCategoryImg: item.ctg_main_img });
                        }}
                      />
                    ))}
                  </MediaQuery>
                </DesignGroupBlock>
                <DesignDetailBlock>
                  <DesignDetailColumn
                    onClick={() => {
                      this.setState({overbtn : ''});
                    }}
                  >
                    <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                      <DesignDetailBtn
                        title={t('all_show')}
                        active={overdetail === 'all'}
                        onClick={() => marketingApi.useClickGnbEffect(t('all_show'))}
                        onMouseEnter={() => {
                          this.setState({ overdetail: 'all' });
                        }}
                      />
                    </Link>
                    {style.slice(0, 7).map((item, index) => (
                      <>
                        <MediaQuery min={1424}>
                          <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                            <DesignDetailBtn
                              key={index}
                              title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                              active={overdetail === item.style_id}
                              onClick={() => marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en)}
                              onMouseEnter={() => {
                                this.setState({ overdetail: item.style_id });
                              }}
                            />
                          </Link>
                        </MediaQuery>
                        <MediaQuery min={1024} max={1423}>
                          <Link to={`/design/${overgroup}/${item.style_id}`} style={{ textDecoration: 'none' }}>
                            <DesignDetailBtn
                              key={index}
                              title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                              active={overdetail === item.style_id}
                              onClick={() => {
                                marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en)
                                this.setState({ overdetail: item.style_id, overbtn: '' });
                              }}
                            />
                          </Link>
                        </MediaQuery>
                      </>
                    ))}
                  </DesignDetailColumn>
                  <DesignDetailColumn
                    onClick={() => {
                      this.setState({overbtn : ''});
                    }}
                  >
                    <Link to={`/design/${overgroup}/one-point`} style={{ textDecoration: 'none' }}>
                      <DesignDetailBtn
                        title={t('one_point_tile_category')}
                        active={overdetail === 'one-point'}
                        onClick={() => marketingApi.useClickGnbEffect(t('one_point_tile_category'))}
                        onMouseEnter={() => {
                          this.setState({ overdetail: 'one-point' });
                        }}
                      />
                    </Link>
                    {style.slice(7, 14).map((item, index) => (
                      <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                        <>
                          <MediaQuery min={1424}>
                            <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                              <DesignDetailBtn
                                key={index}
                                title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                                active={overdetail === item.style_id}
                                onClick={() => marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en)}
                                onMouseEnter={() => {
                                  this.setState({ overdetail: item.style_id });
                                }}
                              />
                            </Link>
                          </MediaQuery>
                          <MediaQuery min={1024} max={1423}>
                            <Link to={`/design/${overgroup}/${item.style_id}`} style={{ textDecoration: 'none' }}>
                              <DesignDetailBtn
                                key={index}
                                title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                                active={overdetail === item.style_id}
                                onClick={() => {
                                  marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en)
                                  this.setState({ overdetail: item.style_id, overbtn: '' });
                                }}
                              />
                            </Link>
                          </MediaQuery>
                        </>
                      </Link>
                    ))}
                    <DesignDetailBtn title={''} />
                  </DesignDetailColumn>
                  <DesignDetailColumn>
                    
                    <MediaQuery min={1424}>
                      <Link to={`/design/${overgroup}/repeat`} style={{ textDecoration: 'none' }}>
                        <DesignDetailBtn
                          title={t('repeat_tile')}
                          active={overdetail === 'repeat'}
                          onClick={() => marketingApi.useClickGnbEffect(t('repeat_tile'))}
                          onMouseEnter={() => {
                            this.setState({ overdetail: 'repeat' });
                          }}
                        />
                      </Link>
                    </MediaQuery>
                    <MediaQuery min={1024} max={1423}>
                      <Link to={`/design/${overgroup}/repeat`} style={{ textDecoration: 'none' }}>
                        <DesignDetailBtn
                          title={t('repeat_tile')}
                          active={overdetail === 'repeat'}
                          onClick={() => {
                            this.setState({ overdetail: 'repeat', overbtn: '' });
                          }}
                        />
                      </Link>
                    </MediaQuery>
                    {style.slice(14).map((item, index) => (
                       <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                       <>
                         <MediaQuery min={1424}>
                           <Link to={`/design/${overgroup}/${overdetail}`} style={{ textDecoration: 'none' }}>
                             <DesignDetailBtn
                               key={index}
                               title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                               active={overdetail === item.style_id}
                               onClick={() => this.setState({ overdetail: item.style_id, overbtn: '' })}
                               onMouseEnter={() => {
                                 this.setState({ overdetail: item.style_id });
                               }}
                             />
                           </Link>
                         </MediaQuery>
                         <MediaQuery min={1024} max={1423}>
                           <Link to={`/design/${overgroup}/${item.style_id}`} style={{ textDecoration: 'none' }}>
                             <DesignDetailBtn
                               key={index}
                               title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                               active={overdetail === item.style_id}
                               onClick={() => {
                                 marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en)
                                 this.setState({ overdetail: item.style_id, overbtn: '' });
                               }}
                             />
                           </Link>
                         </MediaQuery>
                       </>
                     </Link>
                    ))}
                    <DesignDetailBtn title={''} />
                  </DesignDetailColumn>
                  <div
                    style={{
                      paddingLeft: 27,
                      paddingTop: 10,
                      backgroundImage:
                        overgroup === 'all'
                          ? `url(${images.all_design_img})`
                          : `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}${activeCategoryImg})`,
                      flex: 1,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}
                  ></div>
                </DesignDetailBlock>
              </DesignMenu>
            )}
          </MediaQuery>
          {overbtn === 'search' && (
            <SearchMenu
              onClose={() => {
                this.setState({ overbtn: '' });
              }}
            >
              <SearchBase>
                <div style={{ width: '100%' }}>
                  <Select
                    options={keywordList}
                    placeholder=""
                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    styles={searchStyle}
                    noOptionsMessage={() => t('search_no_data')}
                    onChange={(e) => {
                      return this.goSearch(e.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && searchkey.length > 0) {
                        return this.goSearch(searchkey);
                      }
                    }}
                    onInputChange={(value) => {
                      if (value.length > 0) {
                        this.setState({ searchkey: value }, () => {
                          this.getKeyword();
                        });
                      } else {
                        this.setState({
                          keywordList: [],
                        });
                      }
                    }}
                  />
                </div>
                <Button
                  size="small"
                  style={{ minWidth: 40 }}
                  onClick={() => {
                    this.setState({ searchkey: '', keywordList: [] });
                  }}
                >
                  <img alt="" src={images.topmenu_close} />
                </Button>
                <Button size="small" style={{ minWidth: 40 }} onClick={() => this.goSearch(searchkey)}>
                  <img alt="" src={images.topbar_search} />
                </Button>
              </SearchBase>
            </SearchMenu>
          )}

          {/* ------------------------------ 모바일, 테블릿 좌측 메뉴 ---------------------------- */}
          
          <Drawer
            anchor={'left'}
            open={draweropen}
            onClose={() => {
              this.setState({ draweropen: false });
            }}
          >
            <div
              style={{
                width: 'auto',
                position: 'relative',
                height: '100%',
                marginTop: 60,
                display: 'flex',
                minWidth: 268.68,
                flexDirection: 'column',
              }}
            >
              {overbtn === '' && (
                <List>
                  {/* 1. 디자인  */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={true}
                    button
                    divider
                    onClick={() => {
                      this.setState({ overbtn: 'design' });
                    }}
                    title={t('header_menu_design')}
                  />
                  {/* 2. AI 디자인 생성 서비스 */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={false}
                    button
                    divider
                    onClick={this.onGoAIGenerateIntro}
                    trans={t}
                    title={t('ai_generate')}
                  />
                  {/* 3. 미국 저작권 등록 AI 서비스 */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={false}
                    button
                    divider
                    onClick={this.onGoAgentIntro}
                    title={t('us_copyright_agent_service')}
                  />
                  {/* 4. 트렌드  */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={false}
                    button
                    divider
                    onClick={this.onGoTrends}
                    title={t('trend')} />
                  {/* 5. 가격  */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={true}
                    button
                    divider
                    onClick={() => {
                      this.setState({ overbtn: 'price' });
                    }}
                    title={t('price')} />
                  {/* 6. 가이드  */}
                  <GnbExpoMenu
                    leftMenu={true}
                    imgVisible={true}
                    button
                    divider
                    onClick={() => {
                      this.setState({ overbtn: 'guide' });
                    }}
                    title={t('guide')}
                  />
                </List>
              )}

              {overbtn === 'design' && (
                <List>
                  <GnbPrevMenu
                    leftMenu = {true}
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('header_menu_design'));
                      this.setState({ overbtn: '' });
                    }}
                    title={t('header_menu_design')}
                  />
                  <div
                    onClick={() =>
                      this.setState({
                        overbtn: 'category',
                        selectCategory: 'all',
                        selectCategoryNameKo: '모든 디자인',
                        selectCategoryNameEn: 'All Designs',
                      })
                    }
                  >
                    <GnbExpoMenuVer2 
                      onClick={() => { marketingApi.useClickGnbEffect(t('all_designs')) }} 
                      button 
                      divider 
                      title={t('all_designs')} 
                    />
                  </div>
                  {store.getState().category.map((item, index) => (
                    <div
                      onClick={() => {
                        marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.ctg_name_ko : item.ctg_name_en);
                        this.setState({
                          overbtn: 'category',
                          selectCategory: item.ctg_id,
                          selectCategoryNameKo: item.ctg_name_ko,
                          selectCategoryNameEn: item.ctg_name_en,
                        })
                      }}
                    >
                      <GnbExpoMenuVer2
                        key={`category-${index}`}
                        button
                        divider
                        title={Store.get('lang') === 'kr' ? item.ctg_name_ko : item.ctg_name_en}
                      />
                    </div>
                  ))}
                </List>
              )}
              {overbtn === 'category' && (
                <List>
                  <GnbPrevMenu
                    leftMenu = {true}
                    button
                    divider
                    onClick={() => {
                      this.setState({ overbtn: 'design' });
                    }}
                    title={Store.get('lang') === 'kr' ? selectCategoryNameKo : selectCategoryNameEn}
                  />
                  <Link
                    to={`/design/${selectCategory}/all`}
                    style={{ textDecoration: 'none' }}
                    onClick={() => this.setState({ draweropen: false, basketdraweropen: false, overbtn: 'design' })}
                  >
                    <GnbMenuItemVer2 onClick={() => { marketingApi.useClickGnbEffect(t('all_show')) }} button divider title={t('all_show')} />
                  </Link>
                  {store.getState().style.map((item, index) => (
                    <Link
                      to={`/design/${selectCategory}/${item.style_id}`}
                      style={{ textDecoration: 'none' }}
                      onClick={() => this.setState({ draweropen: false, basketdraweropen: false, overbtn: 'design' })}
                    >
                      <GnbMenuItemVer2
                        key={`style-${index}`}
                        button
                        divider
                        onClick={() => { marketingApi.useClickGnbEffect(Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en) }}
                        title={Store.get('lang') === 'kr' ? item.style_name_ko : item.style_name_en}
                      />
                    </Link>
                  ))}
                </List>
              )}
              {overbtn === 'service' && (
                <List>
                  <GnbPrevMenu
                    leftMenu = {true}
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('header_menu_service'));
                      this.setState({ overbtn: '' });
                    }}
                    title={t('header_menu_service')}
                  />
                  <GnbMenuItemVer3 button divider onClick={this.onGoBankIntro} title={t('header_menu_textile')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoAgentIntro} title={t('header_menu_us_copyright')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoFaqIntro} title={'FAQ'} />
                </List>
              )}
              {overbtn === 'price' && (
                <List>
                  <GnbPrevMenu
                    leftMenu = {true}
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('header_menu_price'));
                      this.setState({ overbtn: '' });
                    }}
                    title={t('price')}
                  />
                  <GnbMenuItemVer3 button divider onClick={this.onGoLicenseGuide} title={t('design_licensev2')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoAIGeneratePrice} title={t('ai_generate_pricev2')} />
                </List>
              )}
              {overbtn === 'guide' && (
                <List>
                  <GnbPrevMenu
                    leftMenu = {true}
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('header_menu_guide'));
                      this.setState({ overbtn: '' });
                    }}
                    title={t('header_menu_guide')}
                  />
                  <GnbMenuItemVer3 button divider onClick={this.onGoLicenseGuide} title={t('design_license')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoSellerGuide} title={t('guide_for_sellers')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoBuyerGuide} title={t('guide_for_buyer')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoVipGuide} title={t('what_is_vip_seller')} />
                </List>
              )}
              {overbtn === 'ai_generate' && (
                <List>
                  <GnbPrevMenu
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('ai_generate'));
                      this.setState({ overbtn: '' });
                    }}
                    title={t('ai_generate')}
                  />
                  <GnbMenuItemVer3 button divider onClick={this.onGoAIGenerateIntro} title={t('ai_generate_intro')} />
                  <GnbMenuItemVer3 button divider onClick={this.onGoAIGenerateService} title={t('ai_generate_page')} />
                </List>
              )}


              {/* 마이페이지 -모바일,태블릿 */}
              {overbtn === 'mypage' && (
                <List>
                  <GnbPrevMenu
                    button
                    divider
                    onClick={() => {
                      marketingApi.useClickGnbEffect(t('mypage'));
                      console.log('');
                      this.setState({ overbtn: '' });
                    }}
                    title={t('mypage')}
                  />
                  {/* 1.기본정보 */}
                  <GnbMenuGroup button divider title={t('general_menu')} style={{ backgroundColor: '#cccccc' }} />
                  <GnbMenuItem button divider onClick={this.onBasicPage} title={t('my_profile')} />
                  <GnbMenuItem button divider onClick={this.onReqSeller} title={t('apply_seller_account')} />
                  <GnbMenuItem button divider onClick={this.onAlarmList} title={t('notifications')} />
                  <GnbMenuItem button divider onClick={this.onSvcCenter} title={t('contact_support')} />
                  {/* 2. 구매정보 */}
                  <GnbMenuGroup button divider title={t('menu_for_buyer')} style={{ backgroundColor: '#cccccc' }} />
                  <GnbMenuItem button divider onClick={this.onPurchase} title={t('transactions_buy')} />
                  <GnbMenuItem button divider onClick={this.onBasket} title={t('shopping_cart')} />
                  <GnbMenuItem button divider onClick={this.onFavority} title={t('favorite_boxes')} />
                  <GnbMenuItem button divider onClick={this.onDesigner} title={t('following')} />

                  {/* 셀러 계정으로 로그인 한 경우  */}
                  {store.getState().seller_account_status === 3 && (
                    <>
                      <GnbMenuGroup
                        button
                        divider
                        title={t('menu_for_seller')}
                        style={{ backgroundColor: '#cccccc' }}
                      />
                      <GnbMenuItem button divider onClick={this.onSales} title={t('my_designs')} />
                      <GnbMenuItem button divider onClick={this.onSell} title={t('transactions_sell')} />
                      <GnbMenuItem button divider onClick={this.onWithdrawal} title={t('withdrawal_request')} />
                      <GnbMenuItem button divider onClick={this.onCalculate} title={t('statements')} />
                    </>
                  )}
                  {/* 3 . AI 생성 서비스  */}
                  <GnbMenuGroup button divider title={t('ai_generate')} style={{ backgroundColor: '#cccccc' }} />
                  <GnbMenuItem button divider onClick={this.onGoAIGenerateResult} title={t('generate_result')} />
                  <GnbMenuItem button divider onClick={this.onGoAIGeneratePurchase} title={t('ai_purchase')} />
                  <GnbMenuItem button divider onClick={this.onGoAIGenerateBasket} title={t('ai_basket')} />

                  {/* 4-1. 미국 저작권 등록 AI 서비스 */}
                  <GnbMenuItem
                    button
                    divider
                    onClick={this.onAgencyList}
                    title={t('us_copyright_agent_service')}
                    style={{ backgroundColor: '#cccccc' }}
                  />
                  {store.getState().seller_account_status === 3 ?
                    (
                      /* seller인 경우, AI 생성 결과 */
                      <GnbMenuItem
                        button
                        divider
                        onClick={this.onGoAiGenerate}
                        title={t('ai_generate_result2')}
                        style={{ backgroundColor: '#cccccc' }}
                      />)
                    :
                    (
                      /*buyer인 경우, 판매 계정 신청 */
                      <GnbMenuItem
                        button
                        divider
                        onClick={this.onReqSeller}
                        title={t('apply_for_vip_seller_3')}
                        style={{ backgroundColor: '#cccccc' }}
                      />)
                  }
                  <GnbMenuItem button divider onClick={this.onLogout} title={t('sign_out')} />
                </List>
              )}
              <div style={{ flex: 1 }} />
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems:"center", marginTop: 20, marginBottom: 10, }}>
                <div style={{ position: 'relative' }}>
                  <LanguageBtn
                    value={Store.get('lang') ? Store.get('lang') : 'kr'}
                    onChange={(val) => changeLanguage(val)}
                    bottom={false}
                  />
                </div>
              </div>
            </div>
          </Drawer>
          
          <MediaQuery max={1224}>    
            {/*  장바구니(모바일, 태블릿) right Drawer */}
            <Drawer
              anchor={'right'}
              open={isMobile && basketdraweropen}
              onClose={() => {
                this.setState({ basketdraweropen: false });
              }}>

              <div
                style={{
                  width: 'auto',
                  position: 'relative',
                  height: '100%',
                  marginTop: 60,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {overbtn === '' && (
                  <List>
                    {/* 1. 장바구니  */}
                    <GnbExpoMenuVer6
                      button
                      divider
                      onClick={this.onBasket}
                      title={t('shopping_cart')}
                      count={cartCount}
                    ></GnbExpoMenuVer6>

                    {/* 2. AI 디자인 장바구니 */}
                    <GnbExpoMenuVer6
                      button
                      divider
                      onClick={this.onGoAIGenerateBasket}
                      title={t('ai_basket')}
                      count={aiCartCount}
                    ></GnbExpoMenuVer6>
                  </List>
                )}

              </div>
            </Drawer>
            {/*  마이페이지(모바일, 태블릿)  right Drawer */}
          
            <Drawer
              anchor={'right'}
              open={overbtn === 'mypagedraweropen'}
              onClose={() => {
                console.log('close');
                this.setState({ overbtn: '' });
              }}>

              <div
                style={{
                  width: 'auto',
                  position: 'relative',
                  height: '100%',
                  marginTop: 60,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                  <List>
                    {/* 1. 기본정보  */}
                    <GnbExpoMenuVer3
                      button
                      divider
                      imgVisible = {true}
                      onClick={() => {
                        this.setState({ generalDitemopen: !generalDitemopen })
                      }}
                      generalDitemopen={generalDitemopen}
                      title={t('general_menu')}
                      dropState={generalDitemopen}
                    >
                    </GnbExpoMenuVer3>
                    <Collapse in={generalDitemopen} >
                      <GnbMenuItemVer4 button divider onClick={this.onBasicPage} title={t('my_profile')} />
                      <GnbMenuItemVer4 button divider onClick={this.onReqSeller} title={t('apply_seller_account')} />
                      <GnbMenuItemVer4 button divider onClick={this.onAlarmList} title={t('notifications')} />
                      <GnbMenuItemVer4 button divider onClick={this.onSvcCenter} title={t('contact_support')} />
                    </Collapse>
                    {/* 2. 구매정보 */}
                    <GnbExpoMenuVer3
                      button
                      divider
                      imgVisible = {true}
                      onClick={() => {
                        this.setState({ buyerDitemopen: !buyerDitemopen })
                      }}
                      title={t('menu_for_buyer')}
                      dropState={buyerDitemopen}
                    ></GnbExpoMenuVer3>
                    <Collapse in={buyerDitemopen} >
                        <GnbMenuItemVer4 button divider onClick={this.onPurchase} title={t('transactions_buy')} />
                        <GnbMenuItemVer4 button divider onClick={this.onBasket} title={t('shopping_cart')} />
                        <GnbMenuItemVer4 button divider onClick={this.onFavority} title={t('favorite_boxes')} />
                        <GnbMenuItemVer4 button divider onClick={this.onDesigner} title={t('following')} />
                    </Collapse>
                    
                     {store.getState().seller_account_status === 3 && (
                        <>
                         <GnbExpoMenuVerSeller
                          button
                          divider
                          imgVisible = {true}
                          onClick={() => {
                            this.setState({ sellerDitemopen: !sellerDitemopen })
                          }}
                          title={t('menu_for_seller')}
                          dropState={sellerDitemopen}
                        ></GnbExpoMenuVerSeller>
                       
                        <Collapse in={sellerDitemopen} >
                          <GnbMenuItemVer4 button divider onClick={this.onSales} title={t('my_designs')} />
                          <GnbMenuItemVer4 button divider onClick={this.onRegister} title={t('upload_a_design')} />
                          <GnbMenuItemVer4 button divider onClick={this.onSell} title={t('sale_list')} />
                          <GnbMenuItemVer4 button divider onClick={this.onWithdrawal} title={t('my_designs')} />
                          <GnbMenuItemVer4 button divider onClick={this.onCalculate} title={t('statements')} />
                        </Collapse>
                        </>
                      )}
                    
                    {/* 3. AI 디자인제작 서비스  */}
                    <GnbExpoMenuVer3
                      button
                      divider
                      imgVisible = {true}
                      onClick={() => {
                        this.setState({ aiDitemopen: !aiDitemopen })
                      }}
                      title={t('ai_generate')}
                      dropState={aiDitemopen}
                    ></GnbExpoMenuVer3>
                    <Collapse in={aiDitemopen} >
                      <GnbMenuItemVer4 button divider onClick={this.onGoAIGenerateService} title={t('ai_generate2')} />
                      <GnbMenuItemVer4 button divider onClick={this.onGoAiGenerate} title={t('ai_generate_result2')} />
                      <GnbMenuItemVer4 button divider onClick={this.onGoAIGeneratePurchase} title={t('ai_purchase_history')} />
                      <GnbMenuItemVer4 button divider onClick={this.onGoAIGenerateBasket} title={t('ai_basket')} />
                    </Collapse>

                    {/* 크레딧 관리 메뉴 */}
                    <GnbExpoMenuVer3
                      button
                      divider
                      imgVisible = {true}
                      onClick={() => {
                        this.setState({ creditDitemopen: !creditDitemopen })
                      }}
                      title={t('credit_purchase_history')}
                      dropState={creditDitemopen}
                    ></GnbExpoMenuVer3>
                    <Collapse in={creditDitemopen} >
                      <GnbMenuItemVer4 button divider onClick={this.onCreditPurchaseList} title={t('transactions_buy')} />
                      {/* <GnbMenuItemVer4 button divider onClick={this.onCreditRefundList} title={t('refund_list')} /> */}

                    </Collapse>


                    {/* 4. 미국 저작권 등록 AI 서비스  */}
                    <GnbExpoMenuVer3
                      button
                      divider
                      imgVisible = {true}
                      onClick={() => {
                        this.setState({ uscopyrightDitemopen: !uscopyrightDitemopen })
                      }}
                      title={t('us_copyright_agent_service')}
                      dropState={uscopyrightDitemopen}
                    ></GnbExpoMenuVer3>
                    <Collapse in={uscopyrightDitemopen} >
                      <GnbMenuItemVer4 button divider onClick={this.onApplyAgent} title={t('brokerage_textile_designers2')} />
                      <GnbMenuItemVer4 button divider onClick={this.onAgencyList} title={t('my_copyright')} />
                    </Collapse>
                    {/* 5. VIP 셀러 신청하기 (셀러인지 아닌지에 따른 분기)  */}
                    <Collapse in={true}>
                      <GnbExpoMenuVer3
                        nonimg={true}
                        button
                        divider
                        imgVisible = {false}
                        onClick={this.onGoApplyForVIPSeller}
                        title={t('apply_for_vip_seller')}
                      ></GnbExpoMenuVer3>
                    </Collapse>

                    <VerticalSp sp={20} />
                  </List>


                <div style={{ flex: 1 }} />
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                      <div style={{ position: 'relative' , width:'100%' }}>
                      <HSLine bgcolor="#dddddd" />
                      <GnbExpoMenuVer5
                      button
                      divider
                      title={t('sign_out')}
                      onClick={this.onLogout}
                    >
                    </GnbExpoMenuVer5>

                      </div>
                    </div>

              </div>
            </Drawer>
          </MediaQuery>
        </div>
        <TopBar></TopBar>
      </>
    );
  }
}

export default connect()(withTranslation()(withRouter(Header)));
